export enum IssueType {
  Delay = "DELAY",
  Misdelivery = "MISDELIVERY",
  Misload = "MISLOAD",
  Missing = "MISSING",
  CollectionMiss = "COLLECTION_MISS",
  Damage = "DAMAGE",
  Undeliverable = "UNDELIVERABLE",
  ProofMissing = "PROOF_MISSING",
  Claim = "CLAIM",
  Etc = "ETC",
}

export const issueTypeLabel: Record<IssueType, string> = {
  [IssueType.Delay]: "지연",
  [IssueType.Misdelivery]: "오배송",
  [IssueType.Misload]: "오상차",
  [IssueType.Missing]: "누락",
  [IssueType.CollectionMiss]: "회수누락",
  [IssueType.Damage]: "파손",
  [IssueType.Undeliverable]: "전달불가",
  [IssueType.ProofMissing]: "증빙누락",
  [IssueType.Claim]: "클레임",
  [IssueType.Etc]: "기타",
};

export enum IssueResponsibility {
  Onggoing = "ONGGOING",
  Driver = "DRIVER",
  Shipper = "SHIPPER",
  Supplier = "SUPPLIER",
  Customer = "CUSTOMER",
  External = "EXTERNAL",
  Unknown = "UNKNOWN",
}

export const issueResponsibilityLabel: Record<IssueResponsibility, string> = {
  [IssueResponsibility.Onggoing]: "옹고잉",
  [IssueResponsibility.Driver]: "배송원",
  [IssueResponsibility.Shipper]: "화주사",
  [IssueResponsibility.Supplier]: "공급사",
  [IssueResponsibility.Customer]: "고객사",
  [IssueResponsibility.External]: "외부요인",
  [IssueResponsibility.Unknown]: "확인불가",
};

export enum IssueActionStatus {
  Done = "DONE",
  InProgress = "IN_PROGRESS",
  Impossible = "IMPOSSIBLE",
  NeedsCheck = "NEEDS_CHECK",
}

export const issueActionStatusLabel: Record<IssueActionStatus, string> = {
  [IssueActionStatus.Done]: "조치 완료",
  [IssueActionStatus.InProgress]: "진행 중",
  [IssueActionStatus.Impossible]: "조치 불가",
  [IssueActionStatus.NeedsCheck]: "확인 필요",
};

export interface DeliveryIssue {
  id: string;
  deliveryId: string;
  issueType: IssueType;
  responsibility: IssueResponsibility;
  actionStatus: IssueActionStatus;
  memo: string | null;
  createdByUserId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDeliveryIssuePayload {
  deliveryId: string;
  issueType: IssueType;
  responsibility?: IssueResponsibility;
  actionStatus?: IssueActionStatus;
  memo?: string;
}

export interface UpdateDeliveryIssuePayload {
  issueType?: IssueType;
  responsibility?: IssueResponsibility;
  actionStatus?: IssueActionStatus;
  memo?: string;
}
